import { Component, OnInit } from '@angular/core';
import * as packageInfo from '../../../../package.json';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  packageInfo?: any;
  constructor() {}

  ngOnInit(): void {
    this.packageInfo = packageInfo;
  }
}
